export const navHrefTransfer = (url: string): string => {
  if (url && process.env.NODE_ENV === 'production' && process.env.CLIENT === 'electron') {
    // electron 环境下需要对url进行转换
    return window.location.href.split('#')[0] + url.slice(1)
  }
  return url
}
